<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="报告名称">
              <a-input placeholder="请输入报告名称" v-model="queryParam.reportName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="报告状态">
              <a-input placeholder="请输入报告状态" v-model="queryParam.reportStatus"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="事件描述">
                <a-input placeholder="请输入事件描述" v-model="queryParam.description"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('模型事件报告')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <iot-model-event-report-modal ref="modalForm" @ok="modalFormOk"></iot-model-event-report-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import IotModelEventReportModal from './modules/IotModelEventReportModal'

  export default {
    name: 'IotModelEventReportList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      IotModelEventReportModal
    },
    data () {
      return {
        description: '模型事件报告管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'序号',
            align:"center",
            sorter: true,
            dataIndex: 'orderNo'
          },
          {
            title:'报告名称',
            align:"center",
            sorter: true,
            dataIndex: 'reportName'
          },
          {
            title:'报告状态',
            align:"center",
            sorter: true,
            dataIndex: 'reportStatus_dictText'
          },
          {
            title:'负责人',
            align:"center",
            sorter: true,
            dataIndex: 'manager_dictText'
          },
          {
            title:'事件描述',
            align:"center",
            dataIndex: 'description'
          },
          {
            title:'可能原因',
            align:"center",
            dataIndex: 'possibleCause'
          },
          {
            title:'处理建议',
            align:"center",
            dataIndex: 'suggest'
          },
          {
            title:'现场反馈',
            align:"center",
            dataIndex: 'feedback'
          },
          {
            title:'是否有效告警',
            align:"center",
            sorter: true,
            dataIndex: 'effective_dictText'
          },
          {
            title:'影响程度',
            align:"center",
            sorter: true,
            dataIndex: 'impact'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/org.jeecg.modules.monitor/iotModelEventReport/list",
          delete: "/org.jeecg.modules.monitor/iotModelEventReport/delete",
          deleteBatch: "/org.jeecg.modules.monitor/iotModelEventReport/deleteBatch",
          exportXlsUrl: "/org.jeecg.modules.monitor/iotModelEventReport/exportXls",
          importExcelUrl: "org.jeecg.modules.monitor/iotModelEventReport/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'orderNo',text:'序号',dictCode:''})
        fieldList.push({type:'string',value:'reportName',text:'报告名称',dictCode:''})
        fieldList.push({type:'int',value:'reportStatus',text:'报告状态',dictCode:''})
        fieldList.push({type:'string',value:'manager',text:'负责人',dictCode:''})
        fieldList.push({type:'string',value:'description',text:'事件描述',dictCode:''})
        fieldList.push({type:'string',value:'possibleCause',text:'可能原因',dictCode:''})
        fieldList.push({type:'string',value:'suggest',text:'处理建议',dictCode:''})
        fieldList.push({type:'string',value:'feedback',text:'现场反馈',dictCode:''})
        fieldList.push({type:'int',value:'effective',text:'是否有效告警',dictCode:''})
        fieldList.push({type:'int',value:'impact',text:'影响程度',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>